export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-award-line',
      title: 'Quality Materials',
      description: 'We use only premium, industry-leading waterproofing products and materials'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Certified Technicians',
      description: 'Licensed professionals with extensive training and expertise'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Guaranteed Results',
      description: 'Permanent solutions backed by comprehensive warranties'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing',
      description: 'Honest estimates with no hidden fees or surprise charges'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Why Choose <span className="text-teal-600">R&R General Contracting</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Develop, plan, and build the home you've always wanted by employing sound technologies with a focus on high performance and high efficiency
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-slate-100"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-12">
          <div className="flex items-center space-x-4">
            <img
              src="https://static.wixstatic.com/media/0184a2_943aa75fb75944c48058b82b400e8d95~mv2.png/v1/crop/x_5,y_69,w_289,h_165/fill/w_221,h_121,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/bbb-logo-300x300.png"
              alt="BBB A+ Rating"
              className="h-20 w-auto"
            />
          </div>
          <div className="flex items-center space-x-4">
            <img
              src="https://static.wixstatic.com/media/0184a2_b4f4db5cf39a4cecb699350e2b768eec~mv2.png/v1/crop/x_16,y_0,w_525,h_200/fill/w_270,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/authorizeddealermikereed.png"
              alt="Authorized Basement Technologies Dealer"
              className="h-16 w-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
